var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('vac',{attrs:{"end-time":_vm.endTime},scopedSlots:_vm._u([{key:"process",fn:function(ref){
var ref_timeObj = ref.timeObj;
var day = ref_timeObj.d;
var hours = ref_timeObj.h;
var minutes = ref_timeObj.m;
var seconds = ref_timeObj.s;
return _c('span',{},[(day > 0)?_c('span',[_vm._v(_vm._s(day)+" days")]):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(hours)+":"+_vm._s(minutes)+":"+_vm._s(seconds))])])}}])},[_vm._v(" "),_c('span',{attrs:{"slot":"finish"},slot:"finish"},[_vm._v("Expired!")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }